/*(function($){
  
  
   $.fn.aufklappButton = function() {
  
    
  
  return this.each(function() {
     
    var container = $(this);
    $.each(container.children(),function( index, value ){
     var buttonName=$(this).attr('class');
     $(this).addClass("Rte");
   	 $(this).wrap("<div id="+index+" class='Collapsible  Collapsible--large' shopify_attributes='' block=''><div class='Collapsible__Inner'"+(index==0?'style="overflow: visible; height: auto;"':'')+"><div class='Collapsible__Content'></div></div></div>");
	 $('#'+index).prepend("<button class='Collapsible__Button Heading u-h6' data-action='toggle-collapsible' aria-expanded="+(index==0?'true':'false')+"><h2 class='p'>"+ buttonName +"</h2><span class='Collapsible__Plus'></span></button>");
    });
    
      }
   )
}

 

  
})(jQuery);*/

(function($){
    $.fn.aufklappButton = function() {
        const lang = language_iso;

        // Übersetzungs-Dictionary (Key ist immer lowercase)
        const translationDict = {
            "inhaltsstoffe": { "en": "Ingredients", "de": "Inhaltsstoffe", "nl": "Ingrediënten" },
            "highlights": { "en": "Highlights", "de": "Highlights", "nl": "Hoogtepunten" },
            "warum du es lieben wirst": { "en": "Why You'll Love It", "de": "Warum du es lieben wirst", "nl": "Waarom je het geweldig zult vinden" },
            "vorteile": { "en": "Benefits", "de": "Vorteile", "nl": "Voordelen" },
            "anwendung": { "en": "Application", "de": "Anwendung", "nl": "Toepassing" },
            "beschreibung": { "en": "Description", "de": "Beschreibung", "nl": "Beschrijving" },
            "zu verwenden bei": { "en": "To Use For", "de": "Zu Verwenden bei", "nl": "Te gebruiken bij" },
            "vorteile und wirkung": { "en": "Benefits & Effects", "de": "Vorteile und Wirkung", "nl": "Voordelen & Effecten" }
        };

        return this.each(function(containerIndex) {
            var container = $(this);

            $.each(container.children(), function(index, value) {
                var uniqueId = 'collapsible-' + containerIndex + '-' + index;
                var buttonName = $(this).attr('class').toLowerCase(); // Button-Name in Kleinbuchstaben umwandeln

                var translatedButtonName = translationDict[buttonName] ? 
                    (translationDict[buttonName][lang] || translationDict[buttonName]["de"]) : 
                    buttonName;

                $(this).addClass("Rte");
                $(this).attr('data-id', buttonName);
                $(this).wrap("<div id='" + uniqueId + "' class='Collapsible Collapsible--large'><div class='Collapsible__Inner'" + (index == 0 ? 'style=\"overflow: visible; height: auto;\"' : '') + "><div class='Collapsible__Content'></div></div></div>");
                $('#' + uniqueId).prepend("<button class='Collapsible__Button Heading u-h6' data-action='toggle-collapsible' aria-expanded='" + (index == 0 ? 'true' : 'false') + "'><h2 class='p'>" + translatedButtonName + "</h2><span class='Collapsible__Plus'></span></button>");
            });
        });
    }
})(jQuery);


/*

// hide Treuepunkte
var lastScrollTop = 0;
$(window).scroll(function(event){
  var st = $(this).scrollTop();
  if (st > lastScrollTop){
    if (!$('body').hasClass('down')) {
      $('body').addClass('down');
    }
   } else {
     $('body').removeClass('down');
   }

   lastScrollTop = st;

   if ($(this).scrollTop() <= 0) {
     $('body').removeClass('down');
   };
});

*/
